(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/helpers/customer-service-handlebar-helper.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/helpers/customer-service-handlebar-helper.js'); 

(function() {
  'use strict';

  if (typeof exports === 'object') {
    registerHelpers(require('hbs'));
  } else {
    registerHelpers(Handlebars);
  }

  function registerHelpers(hbs) {

    hbs.registerHelper('convertSize', function(bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) {
        return '';
      }
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) {
        return bytes + ' ' + sizes[i];
      }
      return (bytes / Math.pow(1024, i)).toFixed(0) + ' ' + sizes[i];
    });

    hbs.registerHelper('newLine', function(text) {
      text = Handlebars.Utils.escapeExpression(text);
      text = text.replace(/(\r\n|\n|\r)/gm, '<br>');
      return new Handlebars.SafeString(text);
    });

    hbs.registerHelper('convertDate', function(date) {
      if (date === null) {
        return '';
      }
      date = date.substring(0, date.indexOf('T'));
      return date;
    });

    hbs.registerHelper('iterFaq', function(context, options) {
      var fn = options.fn,
        inverse = options.inverse;
      var ret = '';

      if (context && context.length > 0) {
        for (var i = 0, j = context.length; i < j; i++) {
          var v = i <= 4 ? 'show' : 'hide';
          ret = ret + fn(_.extend({}, context[i], { i: i, index: i + 1, visible: v }));
        }
      } else {
        ret = inverse(this);
      }
      return ret;
    });
  }
})();

 })(window);